/* Batch 15 · N4 (F-118) — the one in-app dialog that replaces every native browser box (window.prompt / confirm / alert).
   Pages call askConfirm / askPrompt / askAlert and await the answer; <AppDialogHost /> (components/AppDialog.jsx, mounted
   once in App.js) renders it in the app's language and direction. Without a host (unit tests) a confirm answers false and
   a prompt null — never a silent "yes". */
let handler = null;

export function registerAppDialogHandler(fn) { handler = fn; }

/** Resolves true (OK) or false (Cancel / closed). opts: { title, okLabel, cancelLabel, danger } */
export function askConfirm(message, opts = {}) {
  if (!handler) return Promise.resolve(false);
  return handler({ kind: "confirm", message: String(message ?? ""), ...opts });
}

/** Resolves the typed string, or null on Cancel / close. opts: { title, okLabel, required (default true), mustChange,
    multiline, placeholder }. With `required` the OK button stays disabled while the field is blank; with `mustChange`
    also while the value equals the prefilled one (the rename rule). */
export function askPrompt(message, defaultValue = "", opts = {}) {
  if (!handler) return Promise.resolve(null);
  return handler({ kind: "prompt", message: String(message ?? ""), defaultValue: defaultValue == null ? "" : String(defaultValue), required: true, ...opts });
}

/** Resolves when closed. */
export function askAlert(message, opts = {}) {
  if (!handler) return Promise.resolve(undefined);
  return handler({ kind: "alert", message: String(message ?? ""), ...opts }).then(() => undefined);
}
